import type { FC } from "react";

import {
  SHEET_HEADER_CLASS,
  type TSheetHeaderProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { cn } from "@/ui/lib/utils";

export const SheetHeader: FC<TSheetHeaderProps> = (
  {
    className,
    ...props
  },
) => (
  <div
    data-component="SheetHeader"
    className={cn(
      SHEET_HEADER_CLASS,
      className,
    )}
    {...props}
  />
);

SheetHeader.displayName = "SheetHeader";
